import eventMap from "@/assets/scripts/eventMap";
const { Stats } = window; // npm引用改为cdn引用

export default function ({ to, from, app, router, store }) {
  Stats.event(eventMap.NumShopExposure, {
    pageurl: decodeURIComponent(to.fullPath),
    pagename_new: to.meta?.title || " ",
  });
}
